import {observable} from "@nx-js/observer-util";
import {ISiteChannelModel} from "../../../models/site/channel/ISiteChannelModel";
import {Services} from "../../Services";
import {ChannelService} from "../../channel/ChannelService";
import {INetworkComponent} from "../../../network/types/INetworkComponent";
import {Network} from "../../../network/Network";
import {HttpStatus} from "../../../network/status/HttpStatus";
import {AvatarService} from "../../avatar/AvatarService";
import {ChannelType} from "../../../models/channel/ChannelType";
import {ProductType} from "../../../models/product/ProductType";
import {ISiteChannelRegisterOutgoingModel} from "../../../models/site/channel/ISiteChannelRegisterOutgoingModel";
import {ISiteChannelPartnerError} from "../../../models/site/channel/ISiteChannelPartnerError";
import {ErrorCode} from "../../../network/status/error/ErrorCode";
import {Resources} from "../../../resources/Resources";

export interface ISiteChannelRegisterResult {
    success: boolean;
    redirectUrl?: string;
    partnerError?: ISiteChannelPartnerError;
}

export class SiteChannelService {
    public static siteChannels: ISiteChannelModel[] = observable([]);

    public static dispose(): void {
        this.siteChannels = observable([]);
    }

    public static init(): void {
        Services.beforeInit(this);
    }

    public static async findUrlConnectPartner(invitationId: string | undefined, onboardingId: string | undefined, tokenPartner: string | undefined, endpointPartner: string | undefined, isLogin: boolean, channelType: ChannelType, communityId?: string, referralCode?: string, component?: INetworkComponent): Promise<string> {
        let request = await Network.post(ProductType.PANEL, `/oauth/url/${channelType}/${isLogin}`,
            {
                invitationId: invitationId,
                onboardingId: onboardingId,
                communityId: communityId,
                tokenPartner: tokenPartner,
                endpointPartner: endpointPartner,
                referralCode: referralCode,
            }, component);

        if (request.status == HttpStatus.OK) {
            return decodeURIComponent(request.data);
        }

        return undefined;
    }

    public static async register(registerOutgoingModel: ISiteChannelRegisterOutgoingModel): Promise<ISiteChannelRegisterResult> {
        const request = await Network.postJson(ProductType.PANEL, `/site/channel/register`, registerOutgoingModel);

        if (request.status == HttpStatus.OK) {
            return {success: true, redirectUrl: request.data};
        }

        if (request.status == HttpStatus.BAD_REQUEST && request.data) {
            const errorData = request.data;
            if (errorData.partnerHttpStatus !== undefined || errorData.partnerErrorBody || errorData.partnerRequestUrl) {
                return {
                    success: false,
                    partnerError: {
                        partnerHttpStatus: errorData.partnerHttpStatus,
                        partnerErrorBody: errorData.partnerErrorBody,
                        partnerRequestUrl: errorData.partnerRequestUrl,
                        partnerResponseHeaders: errorData.partnerResponseHeaders
                    }
                };
            }
        }

        return {success: false};
    }

    /**
     * store
     */

    public static storeAll(siteChannels: ISiteChannelModel[]): ISiteChannelModel[] {
        for (let key in siteChannels)
            siteChannels[key] = this.store(siteChannels[key]);

        return Services.storeAll(siteChannels);
    }

    public static store(siteChannel: ISiteChannelModel): ISiteChannelModel {
        if (siteChannel.avatar != undefined) {
            siteChannel.avatar = AvatarService.store(siteChannel.avatar);
        }

        siteChannel.channel = ChannelService.findById(siteChannel.channelId);
        return siteChannel;
    }
}